module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route",
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10em",
      "margin-right": "1.6em"
    },
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "edit-switch-bar",
    staticStyle: {
      "margin-top": "8em"
    }
  }, [(_vm.seller_mode) ? _c('div', {
    staticClass: "col-md-3 col-sm-12",
    staticStyle: {
      "margin-bottom": "2em",
      "background": "rgba(247, 242, 241, 0.89)",
      "padding": "1em"
    }
  }, [(_vm.edit_mode) ? _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Editing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])]) : _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Viewing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])])]) : _vm._e(), _vm._v(" "), (_vm.seller_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Edit Post")]) : _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Done Editing")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('h4', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.post.post_title))])])]), _vm._v(" "), _c('div', {}, [_c('section', {
    staticClass: "padding-top-10 padding-bottom-10",
    staticStyle: {
      "background": "#2d3a4b"
    }
  }, [(!_vm.edit_mode) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 pull-left",
    staticStyle: {
      "margin": "0",
      "padding": "1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('a', {
    attrs: {
      "href": _vm.sellpoint.business_username + '/p/' + _vm.post.post_url_name
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.post.post_ownername))]), _vm._v(" "), _vm._l((_vm.post.post_media), function(post_media) {
    return _c('div', {
      staticClass: "item-img"
    }, [(_vm.checkIfVideo(post_media.post_media)) ? _c('iframe', {
      attrs: {
        "width": "420",
        "height": "315",
        "src": post_media.post_media
      }
    }) : _c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": post_media.post_media,
        "alt": ""
      }
    })])
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "item-owner"
  }, [_c('li', [_c('span', [_vm._v(" " + _vm._s(_vm.post.post_time_ago))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.post.post_text))]), _vm._v(" "), _c('br'), _c('br')], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 pull-right",
    staticStyle: {
      "margin": "0",
      "padding": "1em"
    }
  }, _vm._l((_vm.posts), function(post) {
    return _c('div', [_c('div', {
      staticClass: "card",
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.sellpoint.business_username + '/p/' + post.post_url_name
      }
    }, [_c('p', [_vm._v(_vm._s(post.post_ownername))]), _vm._v(" "), _vm._l((post.post_media), function(post_media) {
      return _c('div', {
        staticClass: "item-img"
      }, [(_vm.checkIfVideo(post_media.post_media)) ? _c('iframe', {
        attrs: {
          "width": "420",
          "height": "315",
          "src": post_media.post_media
        }
      }) : _c('img', {
        staticClass: "img-1 sp-prd-img",
        attrs: {
          "src": post_media.post_media,
          "alt": ""
        }
      })])
    }), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('ul', {
      staticClass: "item-owner"
    }, [_c('li', [_c('span', [_vm._v(" " + _vm._s(post.post_time_ago))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.post_text))]), _vm._v(" "), _c('br'), _c('br')], 2)])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "shop-detail"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card sp-p-main col-md-6",
    staticStyle: {
      "padding": "2em"
    }
  }, [_c('div', [(_vm.editPostPanel) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('h6', [_vm._v("Edit Post")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Title\r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_title),
      expression: "post.post_title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Post\r\n                                        "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_text),
      expression: "post.post_text"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.post.post_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_text = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editPost
    }
  }, [_vm._v("Save Post")])])])])]) : _c('div', [_c('button', {
    staticClass: "btn btn-xs pull-right action-btn",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-post', '')
      }
    }
  }, [_vm._v("Edit Post Details")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', [_c('b', [_vm._v("Post Title: ")]), _vm._v(_vm._s(_vm.post.post_title))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Details: ")]), _vm._v(_vm._s(_vm.post.post_text))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('remove-post', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Post")]), _vm._v(" "), (_vm.removePostPanel) ? _c('span', {}, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Post?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": _vm.removePost
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "card col-md-5 padding-bottom-100"
  }, [_c('h6', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-weight": "bold"
    }
  }, [_vm._v("Post Pictures")]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.post.post_media), function(pm) {
    return _c('div', {
      staticClass: "img-column"
    }, [(_vm.checkIfVideo(pm.post_media)) ? _c('div', [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    })]) : _c('div', [((pm.post_media && (pm.post_media != 'error'))) ? _c('img', {
      attrs: {
        "src": pm.post_media
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn pull-right",
      staticStyle: {
        "margin-top": "-3em",
        "font-size": "10px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deletePostImage(pm.post_media_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add new media")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*,video/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'posts', _vm.post.post_id)
      }
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "light-gray-bg padding-top-50 padding-bottom-150"
  }, [_c('div', {}, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "heading text-center"
  }, [_c('h4', [_vm._v("These would interest you too")]), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return _c('div', [_c('div', {
      staticClass: "col-md-8 col-md-offset-2"
    }, [_c('a', {
      attrs: {
        "href": _vm.sellpoint.business_username + '/p/' + post.post_url_name
      }
    }, [_c('h4', [_c('a', {
      attrs: {
        "href": _vm.sellpoint.business_username + '/' + post.post_url_name
      }
    }, [_vm._v(_vm._s(post.post_title))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.post_ownername))]), _vm._v(" "), (post.post_media && (post.post_media.length != 0)) ? _c('div', [(_vm.checkIfVideo(post.post_media[0].post_media)) ? _c('iframe', {
      attrs: {
        "width": "420",
        "height": "315",
        "src": post.post_media[0].post_media
      }
    }) : _c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": post.post_media[0].post_media,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('ul', {
      staticClass: "item-owner"
    }, [_c('li', [_c('span', [_vm._v(" " + _vm._s(post.post_time_ago))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.post_text))]), _vm._v(" "), _c('br'), _c('br')])])])
  })], 2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-post-actions"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-heart-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-comment-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-share-alt",
    staticStyle: {
      "color": "#ffffff",
      "text-shadow": "-2px 0 black, 0 2px black, 2px 0 black, 0 -2px black"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-post-actions"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-heart-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-comment-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-share-alt",
    staticStyle: {
      "color": "#ffffff",
      "text-shadow": "-2px 0 black, 0 2px black, 2px 0 black, 0 -2px black"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-post-actions"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-heart-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-comment-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-share-alt",
    staticStyle: {
      "color": "#ffffff",
      "text-shadow": "-2px 0 black, 0 2px black, 2px 0 black, 0 -2px black"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-573d2cde"}!./src/pages/Sellpoint/Post/template.html
// module id = 283
// module chunks = 0